import React from 'react';
import './EditStockMovementModal.css';

function EditStockMovementModal({
  movement,
  showPrice = true,
  hideQuantity = false,
  onClose,
  onSaved,
  requestWithMeta,
}) {
  const id = movement?.id ?? movement?._id;
  const productName = movement?.productName ?? movement?.product_name ?? '—';
  const initialQty = movement?.quantity ?? 0;
  const initialPrice = movement?.productPrice ?? movement?.product_price ?? 0;
  const priceNum = typeof initialPrice === 'number' ? initialPrice : parseFloat(initialPrice) || 0;

  const [quantity, setQuantity] = React.useState(String(initialQty));
  const [price, setPrice] = React.useState(priceNum > 0 ? String(priceNum) : '');
  const [saving, setSaving] = React.useState(false);
  const [error, setError] = React.useState(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError(null);
    const qtyParsed = hideQuantity ? initialQty : parseInt(quantity.trim(), 10);
    const priceParsed = price.trim() === '' ? undefined : parseFloat(price.trim().replace(',', '.'));

    if (!hideQuantity && (!Number.isInteger(qtyParsed) || qtyParsed < 0)) {
      setError('Введите корректное количество');
      return;
    }
    if (showPrice && priceParsed !== undefined && (Number.isNaN(priceParsed) || priceParsed < 0)) {
      setError('Введите корректную цену');
      return;
    }

    setSaving(true);
    try {
      const body = { quantity: qtyParsed };
      if (showPrice && priceParsed !== undefined) body.price = priceParsed;

      const res = await requestWithMeta(
        `/operator/stock-movements/${id}`,
        'PUT',
        body
      );

      if (!res?.ok) {
        setError(res?.data?.error || res?.data?.message || 'Не удалось сохранить');
        return;
      }
      const updated = res?.data?.stockMovement ?? null;
      if (updated) onSaved?.(updated);
      onClose?.();
    } catch (_) {
      setError('Ошибка сохранения');
    } finally {
      setSaving(false);
    }
  };

  return (
    <div
      className="edit-stock-movement-overlay"
      role="dialog"
      aria-modal="true"
      aria-labelledby="edit-stock-movement-title"
      onClick={onClose}
    >
      <div className="edit-stock-movement-card" onClick={(e) => e.stopPropagation()}>
        <div className="edit-stock-movement-header">
          <h2 id="edit-stock-movement-title" className="edit-stock-movement-title">
            Редактировать
          </h2>
          <button
            type="button"
            className="edit-stock-movement-close"
            onClick={onClose}
            aria-label="Закрыть"
            title="Закрыть"
          >
            ×
          </button>
        </div>

        <form onSubmit={handleSubmit} className="edit-stock-movement-form">
          <div className="edit-stock-movement-field">
            <label className="edit-stock-movement-label">
              {hideQuantity && Number(movement?.productId ?? movement?.product_id) === -10
                ? 'Доставка'
                : 'Товар'}
            </label>
            <div className="edit-stock-movement-productName">{productName}</div>
          </div>

          {!hideQuantity ? (
            <div className="edit-stock-movement-field">
              <label htmlFor="edit-stock-movement-qty" className="edit-stock-movement-label">
                Количество
              </label>
              <input
                id="edit-stock-movement-qty"
                type="number"
                min={0}
                step={1}
                value={quantity}
                onChange={(e) => setQuantity(e.target.value)}
                className="edit-stock-movement-input"
                disabled={saving}
              />
            </div>
          ) : null}

          {showPrice ? (
            <div className="edit-stock-movement-field">
              <label htmlFor="edit-stock-movement-price" className="edit-stock-movement-label">
                Цена (за ед.)
              </label>
              <input
                id="edit-stock-movement-price"
                type="number"
                min={0}
                step={0.01}
                value={price}
                onChange={(e) => setPrice(e.target.value)}
                className="edit-stock-movement-input"
                placeholder="0.00"
                disabled={saving}
              />
            </div>
          ) : null}

          {error ? (
            <div className="edit-stock-movement-error" role="alert">
              {error}
            </div>
          ) : null}

          <div className="edit-stock-movement-actions">
            <button
              type="button"
              className="edit-stock-movement-btn edit-stock-movement-btn--secondary"
              onClick={onClose}
              disabled={saving}
            >
              Отмена
            </button>
            <button
              type="submit"
              className="edit-stock-movement-btn edit-stock-movement-btn--primary"
              disabled={saving}
            >
              {saving ? 'Сохранение…' : 'Сохранить'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default EditStockMovementModal;
